import React from 'react';
import PersonalSection from '../components/PersonalSection';

const PersonalPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-nitzan-light-bg via-white to-nitzan-sage/10">
      <div className="pt-20">
        <PersonalSection />
      </div>
    </div>
  );
};

export default PersonalPage;

